<template>
  <div class="reviews-page-mobile">
    <div class="reviews-page-mobile-top">
      <Swiper v-bind="sliderParamsTop">
        <SwiperSlide v-for="(item, index) in result" :key="item.id" @click="updateBottomSlider(index)">
          <div class="reviews-page-mobile-top-item">
            <img
                :src="item.logo.src"
                alt="partners-icon"
                class="reviews-page-mobile-top-item__image"
            />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <div class="reviews-page-mobile-bottom">
      <Swiper v-bind="sliderParamsBottom" ref="bottomSwiper">
        <SwiperSlide v-for="avatar in filteredResult" :key="avatar.id">
          <ReviewsItem :result="avatar" />
        </SwiperSlide>
      </Swiper>
      <div class="reviews-page-mobile-bottom__btns">
        <button class="swiper-button-prev" @click="goToPrevSlide">
          <svg class="icon" width="26" height="20" viewBox="0 0 26 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
            <path d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
            <path d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
            <path d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
          </svg>
        </button>
        <button class="swiper-button-next" @click="goToNextSlide">
          <svg class="icon" width="26" height="20" viewBox="0 0 26 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
            <path d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
            <path d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
            <path d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import { reactive, ref, computed } from "vue";
import { Navigation } from "swiper";
import ReviewsItem from "../../Reviews/ReviewsItem/ReviewsItem.vue";

export default {
  name: 'ReviewsPageMobile',
  props: ['result'],
  components: {
    ReviewsItem,
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const selectedIndex = ref(0);

    const updateBottomSlider = (index) => {
      selectedIndex.value = index;
    };

    const filteredResult = computed(() => {
      return [props.result[selectedIndex.value]];
    });

    const sliderParamsTop = reactive({
      breakpoints: {
        320: {
          slidesPerView: 3.2,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 10,
          spaceBetween: 14,
        },
      },
    });

    const btnNext = ref(null);
    const btnPrev = ref(null);
    const bottomSwiper = ref(null);

    const sliderParamsBottom = reactive({
      slidesPerView: 1,
      modules: [Navigation],
      navigation: {
        prevEl: btnPrev,
        nextEl: btnNext,
      },
      spaceBetween: 30,
    });

    const goToPrevSlide = () => {
      if (selectedIndex.value > 0) {
        selectedIndex.value--;
        updateBottomSlider(selectedIndex.value);
      }
    };

    const goToNextSlide = () => {
      if (selectedIndex.value < props.result.length - 1) {
        selectedIndex.value++;
        updateBottomSlider(selectedIndex.value);
      }
    };

    return {
      sliderParamsBottom,
      btnNext,
      btnPrev,
      sliderParamsTop,
      result: props.result,
      updateBottomSlider,
      filteredResult,
      goToPrevSlide,
      goToNextSlide,
      bottomSwiper,
    }
  }
}
</script>

<style lang="scss" scoped>
.reviews-page-mobile {

}
.reviews-page-mobile-top{
  margin-bottom: 20px;
}
.reviews-page-mobile-top-item{
  width: 30vw;
  height: 14vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  border: 1px solid #E9EBED;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 1px;
  transition: .2s linear border-color;
  &:hover{
    border-color: #A4AADA;
  }
  &__image{
    display: block;
  }
}
.reviews-page-mobile-bottom{
  position: relative;
  background: #FFFFFF;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  &__btns{
    display: grid;
    grid-template-columns: repeat(2, 50px);
    grid-column-gap: 21px;
    position: absolute;
    bottom: 75px;
    left: 88px;
    @include tablet{
      grid-template-columns: repeat(2, 30px);
      grid-column-gap: 11px;
      bottom: 42px;
      left: 34px;
    }
    @include mobile{
      bottom: 29px;
      left: 25px;
    }
  }
  .swiper-button-next,
  .swiper-button-prev{
    display: block;
    position: static;
  }
}
</style>